import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { ApiCallsV2 } from '../../../api/apiV2';
import { USER_PERIOD_BY_DATE } from '../../../constants/queryKeys';
import { PeriodDataDto } from '../../../api/generated/v2/generated/data-contracts';
import { useAllPeriods } from '../../../hooks/queries/useAllPeriods';

export const usePrefetchPreviousPeriod = (periodData: PeriodDataDto) => {
    const queryClient = useQueryClient();
    const { data: allPeriods } = useAllPeriods();

    useEffect(() => {
        if (!allPeriods) return;

        const currentIndex = allPeriods.findIndex(period => period.startDate?.slice(0, 10) === periodData.startDate.slice(0, 10));

        if (currentIndex <= 0) return;

        const prevPeriod = allPeriods[currentIndex - 1];
        const date = prevPeriod.startDate!.slice(0, 10);

        queryClient.prefetchQuery({
            queryKey: [USER_PERIOD_BY_DATE, date],
            queryFn: () => ApiCallsV2.getUserPeriodByDate({ date }).then(res => res.data),
        });
    }, [queryClient, allPeriods, periodData.startDate]);
};
